import React from 'react'

export default function ExternalLinkBlock(props){
  const {
    homepageBlock,
    externalUrl,
    target,
    className
  } = props

  if(homepageBlock.image) {
    return (
      <a
        href={ externalUrl }
        target='_blank'
        rel="noopener noreferrer" >
        <img
          src={ homepageBlock.image }
          alt='' />
      </a>
    )
  } else {
    return (
      <span

        key={ homepageBlock.id }>
        <a
          href={ externalUrl }
          target={target || '_blank'}
          rel="noopener noreferrer" >
          <div
            className={`homepage-block ${className}`} >
            { homepageBlock.title }
          </div>
        </a>
      </span>
    )
  }
}
